export const getValueToDisplay = (options, values) => {
    var _a;
    if (values.length === 0) {
        throw new Error('Expected values array to not be empty');
    }
    return (((_a = options.find((option) => values.includes(option.value))) === null || _a === void 0 ? void 0 : _a.value) || values[0]);
};
//# sourceMappingURL=ChipContent.utils.js.map